import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';
import { SITE } from '@/constants/site';

export default function ContactInfoSection() {
  const { t } = useTranslation();

  const items = [
    { icon: 'ri-map-pin-2-line', label: t('contact.info.addressLabel'), value: t('contact.info.addressValue'), href: undefined },
    { icon: 'ri-phone-line', label: t('contact.info.phoneLabel'), value: SITE.phone, href: SITE.phoneHref },
    { icon: 'ri-mail-line', label: t('contact.info.emailLabel'), value: SITE.email, href: SITE.emailHref },
    { icon: 'ri-time-line', label: t('contact.info.hoursLabel'), value: t('contact.info.hoursValue'), href: undefined },
  ];

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-current" />
            {t('contact.info.eyebrow')}
          </span>
          <h2 className="mt-4 text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
            {t('contact.info.title')}
          </h2>

          <ul className="mt-8 space-y-4">
            {items.map((item) => (
              <li key={item.label} className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700">
                  <i className={item.icon} />
                </span>
                <div>
                  <p className="text-xs uppercase tracking-[0.14em] text-foreground-500">{item.label}</p>
                  {item.href ? (
                    <a href={item.href} className="mt-1 block text-sm font-medium text-foreground-900 transition-colors duration-200 hover:text-primary-600">
                      {item.value}
                    </a>
                  ) : (
                    <p className="mt-1 text-sm font-medium text-foreground-900">{item.value}</p>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-7">
          <div className="h-full min-h-[320px] overflow-hidden rounded-lg border border-background-200">
            <iframe
              title="Standort S+N Blech- und Metallverarbeitungs GmbH"
              aria-label="Standort S+N Blech- und Metallverarbeitungs GmbH"
              src="https://www.google.com/maps?q=Beierfelder+Str.+22,+08315+Lauter-Bernsbach&output=embed"
              className="h-full min-h-[320px] w-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}